import React from 'react';
import { Skeleton } from '../Skeleton';
import { Body, Footer, Media, Wrapper } from './wrapper';

const ProductCardSkeleton = () => (
  <Wrapper>
    <Body>
      <Media>
        <Skeleton $ratio={3 / 2} />
      </Media>
      <Skeleton $width="80px" $height="16px" />
      <Skeleton $width="100px" $height="16px" />
      <Skeleton $width="90%" $height="24px" />
      <Skeleton $width="60%" $height="16px" />
    </Body>
    <Footer>
      <Skeleton $width="135px" $height="32px" />
    </Footer>
  </Wrapper>
);

export default ProductCardSkeleton;
